import * as React from 'react';
import { ICabinetInfo } from '../pages/DashboardPage/TrackingPage';

export interface ICabinetContext {
  selectedDevice: ICabinetInfo | undefined;
  setSelectedDevice: React.Dispatch<React.SetStateAction<ICabinetInfo | undefined>>;
}

export const CabinetContext = React.createContext<ICabinetContext | null>(null);

export const CabinetProvider: React.FC<{children: React.ReactNode}> = ({
  children,
}) => {
  const [selectedDevice, setSelectedDevice] = React.useState<ICabinetInfo>()
  const data = {
    selectedDevice,
    setSelectedDevice,
  };
  return <CabinetContext.Provider value={data}>{children}</CabinetContext.Provider>;
};
